var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.10413,
    y: 4.88293,
    width: 18.4485,
    height: 16.848,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.82738,
    height: 2.31295,
    transform: "matrix(1 0 0 -1 4.87939 4.88281)",
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18.4028,
    height: 1.5878,
    transform: "matrix(1 0 0 -1 3.14954 9.58691)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.82738,
    height: 2.31295,
    transform: "matrix(1 0 0 -1 16.293 4.88281)",
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.275 11.6292H14.307V12.4132L11.883 17.5732H10.659C11.339 16.1012 12.083 14.7332 12.763 13.2692C12.795 13.2132 12.867 13.0692 12.915 12.9892V12.9812C12.923 12.9732 12.923 12.9732 12.923 12.9732L12.955 12.9092C12.955 12.9092 12.955 12.9012 12.963 12.9012V12.8932C13.019 12.7812 13.075 12.6852 13.131 12.6132H10.275V11.6292Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.50131b2f6064f7defdb6f94ce0b3ba58.svg";
export { ForwardRef as ReactComponent };